import React, { useCallback, useRef, useState } from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { useTranslation } from 'react-i18next';

interface GoogleMiniMapProp {
  defaultCenter: google.maps.LatLngLiteral;
  width: string;
  height: string;
  clickToMarker?: boolean;
}

const GoogleMiniMap: React.FC<GoogleMiniMapProp> = ({
  defaultCenter,
  width,
  height,
  clickToMarker = true,
}) => {
  const { t } = useTranslation();
  const [isFullScreen, setIsFullScreen] = useState(false);
  const mapRef = useRef<google.maps.Map | null>(null);
  const [selectedPosition, setSelectedPosition] =
    useState<google.maps.LatLngLiteral | null>(defaultCenter);

  const handleExitFullScreen = useCallback(() => {
    setIsFullScreen(false);
  }, []);
  const handleMapClick = (event: google.maps.MapMouseEvent) => {
    if (event.latLng && clickToMarker) {
      setSelectedPosition({
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      });
    }
  };
  const handleViewInMapClick = useCallback(() => {
    const mapDiv = mapRef.current?.getDiv();
    const fullscreenControl = mapDiv?.querySelector(
      ".gm-fullscreen-control",
    ) as HTMLElement;

    if (!document.fullscreenElement && fullscreenControl) {
      fullscreenControl.click(); // Trigger the fullscreen control click
      fullscreenControl.addEventListener("click", handleExitFullScreen, {
        once: true,
      });
    }

    setIsFullScreen(true);
  }, [handleExitFullScreen]);
  const icon = {
    url: "../assets/icons/localtion-map.svg",
  };
  return (
    <div className="relative rounded-[1.25rem] overflow-hidden">
      <LoadScript
        googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ""}
      >
        <GoogleMap
          mapContainerStyle={{ width: width, height: height }}
          center={defaultCenter}
          zoom={14}
          options={{
            zoomControl: isFullScreen, // Disable zoom controls
            fullscreenControl: isFullScreen, // Enable fullscreen control
            mapTypeControl: isFullScreen, // Enable map type control
            streetViewControl: isFullScreen, // Disable street view controls
          }}
          onClick={handleMapClick}
          onLoad={(map) => {
            mapRef.current = map;
          }}
        >
          {selectedPosition && (
            <Marker position={selectedPosition} icon={icon} />
          )}
        </GoogleMap>

        {!isFullScreen && (
          <button
            onClick={handleViewInMapClick}
            className="absolute bottom-5 mt-2 bg-white rounded-full text-[#232323] py-[0.8125rem] px-[2.0925rem] z-10 left-1/2 transform -translate-x-1/2"
          >
            {t('View in Map')}
          </button>
        )}
      </LoadScript>
    </div>
  );
};

export default GoogleMiniMap;
